import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RESELLER_PAYMENT_STATUS } from 'src/app/domains/connectivity/models/connectivity.model';

@Component({
  selector: 'gdp-reseller-payment-status',
  template: '<div [class]="statusClass">{{status}}</div>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResellerPaymentStatusComponent implements OnInit {
  @Input('status') status: RESELLER_PAYMENT_STATUS;
  public statusClass: string;
  private classMapping = {
    [RESELLER_PAYMENT_STATUS.PAID]: 'vox-chip vox-chip_aquamarine-text',
    [RESELLER_PAYMENT_STATUS.TO_BE_PAID]: 'vox-chip vox-chip_bright-crimson-text',
  };
  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.statusClass = this.classMapping[this.status];
    this.status = this.status.replace(/#|_/g, ' ') as RESELLER_PAYMENT_STATUS;
  }

}
